export default __webpack_public_path__ + "static/dev-dda71369b1d83c77ddbf45af57f9630c.svg";